module.exports = __webpack_public_path__ + "static/media/checkbox-check-print.fdb58020.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/checkbox-check-print.svg
// module id = 531
// module chunks = 0